module.exports = __webpack_public_path__ + "img/zw2.632e3cd0.webp";